export default __webpack_public_path__ + "static/media/t2Sala1.c50a2ccd.jpg";